export default {"src":"/_next/static/media/input-cross-icon.8e7b8cd7.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};